// extracted by mini-css-extract-plugin
export default {"tabContent":"CustomerDetail_tabContent__kFCf7","tabItem":"CustomerDetail_tabItem__QwvQP"};